export const HOSTNAME_ENV_VAR_NAME = 'HOST_NAME';

// The function is needed to dynamically set HOST_NAME during build stage
// Just defining a variable for process.env doesn't work as next.js converts it to string
// Workaround with process.env[HOSTNAME_ENV_VAR_NAME] allows to pass the needed value
export const getHostName = () =>
  typeof window !== 'undefined'
    ? window.HOST_NAME
    : process.env[HOSTNAME_ENV_VAR_NAME];
